var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.855,
    height: 20.992,
    viewBox: "0 0 29.855 20.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.538 77.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M361.266,101.721l-9.055,9,9.055,9a2.593,2.593,0,0,0,.263-1.124V102.845A2.593,2.593,0,0,0,361.266,101.721Z",
    transform: "translate(-352.211 -101.721)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.453,76H26.845a2.594,2.594,0,0,0-1.124.263L37.294,87.777a2.626,2.626,0,0,0,3.71,0L52.577,76.263A2.593,2.593,0,0,0,51.453,76Z",
    transform: "translate(-25.721 -76)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 77.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.263,101.721A2.593,2.593,0,0,0,0,102.845v15.744a2.593,2.593,0,0,0,.263,1.124l9.055-9Z",
    transform: "translate(0 -101.721)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 87.733)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.522,277.211l-1.281,1.281a4.378,4.378,0,0,1-6.184,0l-1.281-1.281-9.055,9a2.594,2.594,0,0,0,1.124.263H51.453a2.594,2.594,0,0,0,1.124-.263Z",
    transform: "translate(-25.721 -277.211)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.29d77cb02eb013d9aeae8de5477f4bbe.svg";
export { ForwardRef as ReactComponent };